import { render, staticRenderFns } from "./CPIS.vue?vue&type=template&id=1843d96a&scoped=true"
import script from "./CPIS.vue?vue&type=script&lang=js"
export * from "./CPIS.vue?vue&type=script&lang=js"
import style0 from "./CPIS.vue?vue&type=style&index=0&id=1843d96a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1843d96a",
  null
  
)

export default component.exports